import React from 'react';
import { object, string, func, bool } from 'prop-types';
import MaterialUiPhoneNumber from 'material-ui-phone-number';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getLocalization } from '../../../state/reducers/ApplicationReducer';
import { DEFAULT_COUNTRY_CODE } from '../../../constants/countries';

const styles = (theme) => ({
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: '100%',
    marginBottom: 0,
    marginTop: theme.spacing(1),
  },
  label: {
    fontSize: 13,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  container: {
    textAlign: 'left',
  },
});

function Phone(props) {
  let {
    id,
    value,
    onChange,
    readOnly,
    required = false,
    error,
    label,
    classes,
    localization,
    defaultCountryCode,
  } = props;
  return (
    <div key={id} className={classes.container}>
      <MaterialUiPhoneNumber
        value={value}
        label={label}
        onChange={onChange}
        disabled={readOnly}
        required={required}
        error={!!error}
        helperText={error}
        autoFormat={false}
        defaultCountry={required ? defaultCountryCode || DEFAULT_COUNTRY_CODE : ''}
        localization={localization}
        {...(readOnly && { placeholder: '', disableDropdown: true })}
      />
    </div>
  );
}

Phone.propTypes = {
  classes: object.isRequired,
  id: string.isRequired,
  value: string,
  onChange: func.isRequired,
  readOnly: bool.isRequired,
  error: string,
  required: bool,
  label: string.isRequired,
  defaultCountryCode: string,
};

export default compose(
  connect((state) => ({
    localization: getLocalization(state),
  })),
  withStyles(styles)
)(Phone);



// WEBPACK FOOTER //
// ./src/view/forms/components/FormPhoneNumber.js